import StorageObject from 'ember-local-storage/local/object';

export default class VisitorEntryStorage extends StorageObject {
  initialState() {
    return {};
  }
}
